import * as React from 'react';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormComponentProps } from '../../form/Form';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { SatelliteTicketsPanel } from './SatelliteTicketsPanel';
import { Validators } from "../../form/Validators";

const CONFIGURATION_MODEL = 'configuration';
const PRIZE_BOOST_CONFIGURATION_MODEL = 'prizeBoostConfiguration';
const SATELLITE_CONFIGURATION_MODEL = 'satelliteConfiguration';

interface PrizeBoostConfigurationPanelProps extends FormComponentProps {
}

export class PrizeBoostConfigurationPanel extends React.Component<PrizeBoostConfigurationPanelProps, {}> {
    getModel(model) {
        return this.props.fieldSet.getModelValue(model);
    }

    resetTickets(): void {
        const prizeBoostConfiguration = this.getModel(PRIZE_BOOST_CONFIGURATION_MODEL);

        if (prizeBoostConfiguration) {
            prizeBoostConfiguration.tickets = [];
            prizeBoostConfiguration.ticketCount = 0;    
        }
    }

    render(): JSX.Element {
        const configuration = this.getModel(CONFIGURATION_MODEL);
        const satelliteConfiguration = this.getModel(SATELLITE_CONFIGURATION_MODEL);
        const prizeBoostConfiguration = this.getModel(PRIZE_BOOST_CONFIGURATION_MODEL);

        const isEnabled: boolean = prizeBoostConfiguration && prizeBoostConfiguration.enabled;
        const haveBoostPrizeAmount: boolean = isEnabled && prizeBoostConfiguration.boostCash != 0;
        const haveTickets: boolean = prizeBoostConfiguration && prizeBoostConfiguration.tickets && prizeBoostConfiguration.tickets.length > 0;
        const isGuaranteedPrizePoolEnabled: boolean = configuration.guaranteedPrizePool != 0;
        const isSatellite: boolean = satelliteConfiguration && satelliteConfiguration.isSatellite;

        if (haveTickets) {
            prizeBoostConfiguration.boostCash = 0;
        } else {
            this.resetTickets();
        }

        if (isSatellite) {
            this.resetTickets();
        }

        return (
            <FormTransferContainer {...this.props} model={PRIZE_BOOST_CONFIGURATION_MODEL}>
                <div className='row target-tournament-panel'>
                    <div className='col-lg-12'>
                        <div className='ibox-title'>
                            <h5>Prize Boost Configuration</h5>
                        </div>
                        <div className='ibox-content'>
                            <FormGroup className='form-group'>
                                <label className='col-sm-2 control-label'>Is Prize Boost enabled</label>
                                <div className='col-sm-10'>
                                    <FormInput type='checkbox' model='enabled' disabled={isGuaranteedPrizePoolEnabled}/>
                                    <span className='help-block m-b-none'>Prize Boost can not be set with Guaranteed at the same time.</span>
                                </div>
                            </FormGroup>
                            {isEnabled && <div>
                                <div className='hr-line-dashed'></div>
                                {!haveTickets && <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Boost Amount</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='text' model='boostCash' disabled={haveTickets} className='form-control' validators={[Validators.required(), Validators.min(0.01)]} />
                                        <span className='help-block m-b-none'>Defines how much is added to prizepool by Global Poker. Cannot set together with boost tickets.</span>
                                    </div>
                                </FormGroup>}
                                {(!haveBoostPrizeAmount && !isSatellite) && <div>
                                    <div className='hr-line-dashed'></div>
                                    <SatelliteTicketsPanel label='Awards Ticket' model='tickets' singleTicket={true} linkOnly={true}/>
                                    <div className='hr-line-dashed'></div>
                                </div>}
                                {haveTickets && <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Boost Ticket Count</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='text' model='ticketCount' className='form-control' validators={[Validators.required(), Validators.integer(), Validators.range(1, 1000)]} />
                                        <span className='help-block m-b-none'>Must be bigger than zero. Defines how much ticket is added to prizepool by Global Poker</span>
                                    </div>
                                </FormGroup>}
                            </div>}
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/PrizeBoostConfigurationPanel.tsx